enum TaskStatus {
    NotStarted = 'not-started',
    Completed = 'completed',
}

export default TaskStatus;
